package com.example.hukakmp.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.example.hukakmp.data.AchievementsRepository
import com.example.hukakmp.data.FishingRepository
import com.example.hukakmp.model.AchievementState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class AchievementsViewModel(
    private val achievementsRepository: AchievementsRepository,
    private val fishingRepository: FishingRepository,
) : ViewModel() {

    data class AchievementsUiState(
        val isLoading: Boolean = true,
        val achievements: List<AchievementState> = emptyList(),
        val error: String? = null,
    ) {
        val unlockedCount: Int get() = achievements.count { it.isUnlocked }
        val totalCount: Int get() = achievements.size
        val points: Int get() = achievements.filter { it.isUnlocked }.sumOf { it.definition.points }
    }

    private val _uiState = MutableStateFlow(AchievementsUiState())
    val uiState: StateFlow<AchievementsUiState> = _uiState.asStateFlow()

    init {
        refresh()
    }

    fun refresh() {
        viewModelScope.launch {
            _uiState.value = _uiState.value.copy(isLoading = true, error = null)
            try {
                val partes = fishingRepository.obtenerMisPartes(limite = 500)
                val achievements = achievementsRepository.sincronizar(partes)
                _uiState.value = AchievementsUiState(
                    isLoading = false,
                    achievements = achievements,
                )
            } catch (e: Exception) {
                _uiState.value = _uiState.value.copy(
                    isLoading = false,
                    error = e.message ?: "No se pudieron cargar los logros",
                )
            }
        }
    }
}
